import { defineSlotRecipe } from '@chakra-ui/react';
import { fieldAnatomy } from '@chakra-ui/react/anatomy';

export const fieldSlotRecipe = defineSlotRecipe({
	slots: fieldAnatomy.keys(),
	base: {
		root: {
			gap: '2',
			width: 'full',
			height: 'full'
		},
		label: {
			textStyle: 'sm',
			fontWeight: 'semibold',
		},
		helperText: {
			textStyle: 'xs',
		},
		errorText: {
			textStyle: 'xs',
		}
	}
});
